import { Link } from "react-router-dom";
import "@fontsource/poppins";
import about from "../../assets/img/about.webp";
import TestimonialCarousel from "./TestimonialCarousel";
import Registration from "./Registration";
import imgHeader from "../../assets/img/page-header.webp";

const About = () => {
    return (
        <div>
            {/* Header Section */}
            <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: "300px" }}>
                <img
                    src={imgHeader}
                    alt="Encabezado de página curso online"
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                    style={{ zIndex: 0 }}
                    loading="eager"
                    decoding="async"
                />
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "rgba(0, 0, 0, 0.5)", zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2 }}>
                    <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: "300px" }}>
                        <h3 className="display-4 text-white text-uppercase">Conoce al fundador</h3>
                        <div className="d-inline-flex text-white">
                            <p className="m-0 text-uppercase"><Link to="/">Inicio</Link></p>
                            <i className="fa fa-angle-double-right pt-1 px-3"></i>
                            <p className="m-0 text-uppercase">Conoce al fundador</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* About Section */}
            <div className="container-fluid py-5">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <img className="img-fluid rounded mb-4 mb-lg-0" src={about} alt="Conoce al fundador" />
                        </div>
                        <div className="col-lg-7">
                            <div className="text-title-about mb-4">
                                <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Hola soy</h5>
                                <h1>Luis Eduardo Nieto</h1>
                            </div>
                            <p style={{ textAlign: "justify" }}>
                                Soy Ingeniero en Informática, estratega digital, emprendedor y apasionado por la educación online.
                                Durante años he trabajado en el mundo de la tecnología, el desarrollo de software, el marketing digital
                                y la creación de negocios en internet. A lo largo de mi trayectoria he tenido la oportunidad de participar
                                en proyectos tecnológicos, desarrollar soluciones digitales y ayudar a personas a adquirir habilidades que
                                les permitan crecer profesionalmente y generar nuevas oportunidades para su futuro. Sin embargo, descubrí
                                algo que cambió por completo mi visión: el conocimiento tiene el poder de transformar vidas cuando se enseña
                                de forma práctica, sencilla y aplicada al mundo real. Fue así como nació Dissemp Academy.
                            </p>
                            <Link to="/courses" className="btn btn-primary py-md-2 px-md-4 font-weight-semi-bold mt-2">
                                Quiero ver los cursos
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filosofía Section */}
            <div className="container-fluid py-5" style={{ background: "#f8f9fa" }}>
                <div className="container py-4">
                    <div className="text-center mb-5">
                        <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Lo que me guía</h5>
                        <h2 className="font-weight-bold">Mi filosofía de enseñanza</h2>
                        <p className="text-muted mt-3 mx-auto" style={{ maxWidth: "560px" }}>
                            Creo firmemente que aprender no debería ser complicado. Por eso me enfoco en lo que realmente importa.
                        </p>
                    </div>
                    <div className="row justify-content-center">
                        {[
                            { icon: "fa-lightbulb", text: "Explicar conceptos complejos de forma sencilla." },
                            { icon: "fa-chalkboard-teacher", text: "Enseñar con ejemplos reales y aplicables." },
                            { icon: "fa-sync-alt", text: "Compartir conocimientos actualizados y relevantes para el mercado actual." },
                            { icon: "fa-hands-helping", text: "Acompañar a los estudiantes en su proceso de crecimiento." },
                            { icon: "fa-trophy", text: "Crear formaciones orientadas a resultados y no solamente a teoría." },
                        ].map((item, index) => (
                            <div key={index} className="col-md-4 mb-4">
                                <div className="d-flex align-items-start p-4 bg-white rounded shadow-sm h-100">
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-circle mr-3 flex-shrink-0"
                                        style={{ width: "48px", height: "48px", background: "var(--primary)", minWidth: "48px" }}
                                    >
                                        <i className={"fa " + item.icon + " text-white"}></i>
                                    </div>
                                    <p className="m-0 text-dark" style={{ lineHeight: "1.6" }}>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="text-center text-muted mt-4 mx-auto" style={{ maxWidth: "640px" }}>
                        Mi compromiso es que cada estudiante encuentre en <strong>Dissemp Academy</strong> una experiencia de aprendizaje clara, práctica y de alto valor.
                    </p>
                </div>
            </div>

            {/* Comunidad Section */}
            <div
                className="container-fluid py-5"
                style={{ background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 60%, #0f3460 100%)" }}
            >
                <div className="container py-4">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0 text-white">
                            <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>Más que una academia</h5>
                            <h2 className="font-weight-bold text-white mb-4">Una comunidad de crecimiento</h2>
                            <p style={{ lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                Dissemp Academy no es simplemente una plataforma de cursos. Es una comunidad creada para personas que desean
                                aprender, evolucionar y prepararse para las oportunidades del presente y del futuro.
                            </p>
                            <p style={{ lineHeight: "1.8", color: "rgba(255,255,255,0.8)" }}>
                                Nuestro compromiso es seguir creando programas de formación de alta calidad, impartidos por expertos,
                                con contenido práctico y actualizado que genere un impacto real en la vida de nuestros estudiantes.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="p-5 rounded text-center"
                                style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)" }}
                            >
                                <div className="mb-4" style={{ fontSize: "3rem" }}>👋</div>
                                <h4 className="text-white font-weight-bold mb-3">Si has llegado hasta aquí...</h4>
                                <p style={{ color: "rgba(255,255,255,0.75)", lineHeight: "1.8" }}>
                                    Te doy la bienvenida. Espero poder acompañarte en tu proceso de aprendizaje y ayudarte a desarrollar
                                    las habilidades que te acercarán a tus metas personales y profesionales.
                                </p>
                                <p className="text-primary font-weight-bold mt-3 mb-4">Nos vemos dentro de la academia.</p>
                                <Link to="/courses" className="btn btn-primary py-2 px-5 font-weight-semi-bold">
                                    Explorar cursos
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Registration */}
            <Registration />

            {/* Testimonial */}
            <TestimonialCarousel />
        </div>
    );
};

export default About;